export const context = {
    close: {
        label: "Fermer",
        title: "Fermer le panneau contextuel"
    }
}